module.exports = __webpack_public_path__ + "img/wfqwt-icon.73bd5c2.svg";